import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part6 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',
        chapterCinematic42: 'medsurg-cinematic-1-42',
        chapterCinematic43: 'medsurg-cinematic-1-43',
        chapterCinematic44: 'medsurg-cinematic-1-44',
        chapterCinematic45: 'medsurg-cinematic-1-45',
        chapterCinematic46: 'medsurg-cinematic-1-46',
        chapterCinematic47: 'medsurg-cinematic-1-47',
        chapterCinematic48: 'medsurg-cinematic-1-48',
		chapterCinematic76: 'medsurg-cinematic-1-76', // for testing - currently set to female 01
		chapterCinematic77: 'medsurg-cinematic-1-77', // for testing - currently set to female 02
		chapterCinematic74: 'medsurg-cinematic-1-74', // for testing - currently set to male 01
		chapterCinematic75: 'medsurg-cinematic-1-75', // for testing - currently set to male 02
	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PObool: boolean = false;
	
	private avatar1: boolean = false;
	private avatar2: boolean = false;
	private avatar3: boolean = false;
	private avatar4: boolean = false;

	
	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part6.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public start() {
		const context = this;
		if(this.scenario.avatarIndx === 0) {
			this.avatar1 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 1) {
			this.avatar2 = true;
			this.avatar1 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 2) {
			this.avatar3 = true;
			this.avatar2 = false;
			this.avatar1 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 3) {
			this.avatar4 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar1 = false;
		}
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.segment1Part5Debrief();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to part 7',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "Let's go check in with Mr. Fellow in room 2.",
            () => {
                this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				setTimeout(() => {
					this.playVideoChapter(this.chapterIds.chapterCinematic42, () => {
						context.scenario.gameManager.environment.blurFadeIn();
						context.PreloadUis();
						if(this.RememberDisplayed === false) {	
							context.startAnim();
							context.segment1Step4Remember();
						}
						this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '2', '5', false, false);
						context.TalkCount = 2;
						context.ActionCount = 5;
						context.getFooterCounts();
					});
				}, 200);
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		context.scenario.displayDebrief(13300, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

	private startAnim() {
		var context = this;
		setTimeout(() => {
			context.scenario.gameManager.environment.blurFadeOut();
		}, 500);
		this.playVideoChapter(this.chapterIds.chapterCinematic43, () => {}, true);
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario1).PrFellowID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {	
				// 	context.startAnim();
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrFellowID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'Is there anything I can do to make you more comfortable?',
					onClicked: () => {
						this.segment1TalkComfort();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'Have you fallen recently?',
					onClicked: () => {
						this.segment1TalkFallen();
					},
					disable: () => this.Talk2
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '150px',
					titletext: 'Note Battle Sign Bruise',
					onClicked: () => {
						this.segment1ActionBattle();
					},
					disable: () => this.Action1
				},
				{
					toppx: '250px',
					titletext: 'Dim Lights',
					onClicked: () => {
						this.segment1ActionDim();
					},
					disable: () => this.Action2
				},
				{
					toppx: '350px',
					titletext: 'Contact Provider',
					onClicked: () => {
						this.segment1ActionProv();
					},
					disable: () => this.Action3
				},
				{
					toppx: '450px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment1ActionRRT();
					},
					disable: () => this.Action4
				},
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment2ActionFail();
					},
					disable: () => this.Action5
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1TalkComfort() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Is there anything I can do to make you more comfortable?',
			isTalks: true,
			extBottom: true,
			extText: "Yes. Please turn off the lights. I don't know why, but I think they make me feel worse.",
			onSubmit: () => {
				context.scenario.updateScore(50);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic44, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic43, () => {}, true);
		});
	}

	private segment1TalkFallen() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Have you fallen recently?',
			isTalks: true,
			extBottom: true,
			extText: "Yes. I actually fell off my bike while I was out riding on a trail, but I don't remember when I went for a ride or where.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
					title: context.scenario.significantIncidents,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.significantIncidents)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Significant Incidents',
					talktext2: 'Event',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Recent fall',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Recent illness',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Recent international travel',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Recent loss of consciousness',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic45, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic43, () => {}, true);
		});
	}

	private segment1ActionBattle() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Note Battle Sign Bruise',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).fellowNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action1 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 2000,
					talktext1: 'Patient Observations',
					talktext2: 'Skin',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Bruising: Petechiae',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Bruising: Purpura',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Bruising: Battle Sign',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Bruising: General',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Rash',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Dry/scaly',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Inflamed',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic46, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic43, () => {}, true);
		});
	}

	private segment1ActionDim() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Dim Lights',
			isTalks: true,
			onSubmit: () => {
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.updateScore(50);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionProv() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		this.Action3 = true;
		context.getFooterCounts();
	}

	private segment1ActionRRT() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		this.Action4 = true;
		context.getFooterCounts();
	}

	private segment2ActionFail() {
		var context = this;
		this.scenario.gameManager.environment.blurFadeIn();
		this.scenario.displayModalPop(
			null,
            "Your patient has had an adverse event. Please report to the nurses’ station to speak with your charge nurse.",
            () => {
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.scenario.updateFooter('0', '0', true, true);
				context.scenario.hideFooter();
				context.segment2ActionChargeNurse();
            }
        );
	}

	private segment2ActionChargeNurse() {
		var context = this;
		//NEED FAIL ANIM, CHANGE CHAPTERCINEMATICS BELOW TO EACH PLAYER CHARACTER LOOP
		if(this.avatar1) {
			this.playVideoChapter(this.chapterIds.chapterCinematic76, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar2) {
			this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar3) {
			this.playVideoChapter(this.chapterIds.chapterCinematic74, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar4) {
			this.playVideoChapter(this.chapterIds.chapterCinematic75, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		}
		setTimeout(() => {
			context.segment2ActionChargeNurseNext();
		}, 1000);
	}

	private segment2ActionChargeNurseNext() {
		var context = this;
		//context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showRemediation(
			'I would like to discuss Mr. Fellow’s change in condition. When a patient is unstable, the nurse should remain at the bedside and call for help. The Rapid Response Team (RRT) is available to respond to patients who are having a change in condition. A critically ill patient can deteriorate quickly and have a respiratory or cardiac arrest. Intervening earlier by notifying the Provider or RRT would have prevented Mr. Fellow from having an adverse event. Please return to Room #2 and begin caring for your patient again.',
			'./assets/images/general/icons/npc-headshots/ChargeNurse.png',
			() => {
				context.scenario.gameManager.environment.blurFadeOut();
				localStorage.setItem('ignoreResumePopup', 'true');
				window.location.reload();
			}
		)
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.Action4 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment1PartEndingStartRRT();
		}
		else if(this.Action3 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment1PartEndingStartProvider();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private segment1PartEndingStartRRT() {
		var context = this;
		this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {
			context.scenario.gameManager.environment.blurFadeIn();
			context.segment1showSbar();
		});
	}

	private segment1PartEndingStartProvider() {
		var context = this;
		this.playVideoChapter(this.chapterIds.chapterCinematic47, () => {
			context.scenario.gameManager.environment.blurFadeIn();
		});
		context.scenario.showProvider(
			"Hi Nurse, what's the situation?",
			() => {
				context.segment1showSbar();
			}
		);
	}

	private segment1showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 250,
				options: [
					{
						text: 'Hypoglycemia',
						isCorrect: false
					},
					{
						text: 'Battle Bruise',
						isCorrect: true
					},
					{
						text: 'Allergic Reaction',
						isCorrect: false
					},
					{
						text: 'Headache',
						isCorrect: true
					},
					{
						text: 'Vomiting',
						isCorrect: true
					},
					{
						text: 'Confusion',
						isCorrect: true
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).fellowBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).fellowNursesID),
			r: {
				maxPoints: 200,
				options: [
					{
						text: 'CT Scan and Transfer to ICU',
						isCorrect: true
					},
					{
						text: 'Medication',
						isCorrect: false
					},
					{
						text: 'Discharge',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.gameManager.environment.blurFadeOut();
				context.scenario.destroyAllUIInstances();
				if(this.Action4 === true) {
					context.segment1PartEndingRRT();
				}
				else if(this.Action3 === true) {
					context.scenario.showProvider(
						"Thanks for this update. It sounds like Mr. Fellow is experiencing increased intracranial pressure. I'm ordering him transferred to ICU so that we can monitor him more closely. Great work!",
						() => {
							context.segment1PartEndingProv();
						}
					);
				}
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}

	private segment1PartEndingRRT() {
		var context = this;
		context.scenario.showProvider(
			"Okay thank you, we'll take Mr. Fellow to ICU.",
			() => {
				context.segment1Part5Debrief();
			}
		);
	}

	private segment1PartEndingProv() {
		var context = this;
		context.segment1Part5Debrief();
	}
}